import { ViewStream, safeClone } from 'spyne';
import { DeckSlideTraits } from 'traits/deck/deck-slide-traits.js';

export class DeckSlideView extends ViewStream {
  constructor(props = {}) {
    props.data = safeClone(props.data);
    DeckSlideTraits.deckSlide$PrepareData(props.data);

    const { slideName, template, layout } = props.data;

    props.tagName = 'section';
    props.class = `deck-slide deck-slide--${slideName} deck-layout--${layout}`;
    props.dataset = { slideName, template, layout, slideNum: props.slideNum };
    props.channels = [['CHANNEL_DECK', true], 'CHANNEL_SLIDESHOW'];
    props.traits = [DeckSlideTraits];
    props.template = DeckSlideTraits.deckSlide$GetLayoutTemplate(layout);

    super(props);
  }

  addActionListeners() {
    return [
      ['CHANNEL_SLIDESHOW_DISPLAY_SLIDE_EVENT', 'deckSlide$OnDisplaySlide'],
      ['CHANNEL_SLIDESHOW_DEACTIVATED_EVENT', 'deckSlide$OnSlideshowDeactivated'],
    ];
  }

  onRendered() {
    this.deckSlide$onRendered();
  }
}
